import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import 'vue-select/dist/vue-select.css'
// import 'hamburgers/_sass/hamburgers/hamburgers.scss'
import './components'
import './layouts'

import './font-awesome-init'

// import './style.scss';

import Swal from 'sweetalert2/src/sweetalert2.js'
import '@sweetalert2/theme-bootstrap-4/bootstrap-4.css'
window.Swal = Swal

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
